import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps, CardIntentStyles, CardMode } from '../common/props';
import { Divider } from '../divider/Divider';
import { InverseBgProvider } from '../theme/InverseBg';
import { Fragment } from 'react';
import { ContainerProps } from '../types';

export interface ICardProps extends Omit<BaseProps, 'title'> {
  title?: React.ReactNode;
  /**
   * Pokud je true, nezalamuje se dlouhý text do více řádků a aplikují se tři tečky, sndardně se text zalamuje.
   */
  noWrap?: boolean;
  extra?: React.ReactNode;
  mode?: CardMode;
  disableHover?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  sideHeader?: boolean;
  /**
   * Classname pro body, vhodné např. pro padding apod.
   */
  bodyClassName?: string;
  /**
   * Classname pro header.
   */
  headerClassName?: string;
  /**
  /**
   * Typ informace na kartě, pokud není uvedeno, je none.
   */
  intent?: CardIntentStyles;
}

export type CardProps = ICardProps & ContainerProps;

/**
 * Komponenta kartičky.
 */
export class Card extends React.PureComponent<CardProps> {
  render() {
    const {
      noWrap,
      className,
      bodyClassName,
      headerClassName,
      children,
      title,
      extra,
      intent,
      onClick,
      disableHover,
      sideHeader,
      mode = 'default',
      noScroll,
      fullHeight,
      maxFullHeight,
      ...other
    } = this.props;

    let cls = classNames(Classes.CARD, className, {
      [Classes.CARD_NONE]: !intent || intent === 'none',
      [Classes.CARD_INFO]: intent === 'info',
      [Classes.CARD_DANGER]: intent === 'danger',
      [Classes.CARD_SUCCESS]: intent === 'success',
      [Classes.CARD_WARNING]: intent === 'warning',
      [Classes.CARD_INACTIVE]: intent === 'inactive',
      [Classes.CARD_HAS_TITLE]: title || extra,
      [Classes.CARD_HAS_BODY]: !!children,
      [Classes.CARD_NONE_TITLE]: !(title || extra),
      [Classes.CARD_MODE_EDIT]: mode === 'edit',
      [Classes.EDIT_MODE]: mode === 'edit',
      [Classes.CARD_MODE_VIEW]: mode === 'view',
      [Classes.CARD_MODE_SECTION]: mode === 'section',
      [Classes.CARD_MODE_SUBSECTION]: mode === 'subsection',
      [Classes.CARD_MODE_FILTER]: mode === 'filter',
      [Classes.CARD_MODE_DEFAULT]: mode === 'default',
      [Classes.CARD_SIDE_HEADER]: sideHeader,
      [Classes.HOVER_ITEM_CONTAINER]: !disableHover && onClick,
      [Classes.CLICK_CONTAINER]: onClick,
      [Classes.CONTAINER_FULL_HEIGHT]: fullHeight,
      [Classes.NO_SCROLL]: noScroll,
      [Classes.CONTAINER_MAX_HEIGHT]: maxFullHeight,
    });

    let arr: React.ReactNode[] = [];
    React.Children.forEach(children, (child) => {
      if (child) {
        arr.push(child);
      }
    });

    return (
      <div onClick={onClick} {...other} className={cls}>
        {(title || extra) && (
          <InverseBgProvider
            inverse={
              intent === 'success' ||
              intent === 'danger' ||
              intent === 'warning' ||
              intent === 'info'
            }
          >
            <div className={classNames(Classes.CARD_HEADER, headerClassName)}>
              <div
                className={classNames(Classes.CARD_HEADER_TITLE, {
                  [Classes.CARD_HEADER_TITLE_NO_WRAP]: noWrap,
                })}
              >
                {title}
              </div>
              <div className={Classes.CARD_HEADER_EXTRA}>{extra}</div>
            </div>
          </InverseBgProvider>
        )}
        {/*<div className={Classes.CARD_BODY}>{children}</div>*/}
        <InverseBgProvider
          inverse={mode === 'view' || mode === 'edit' ? false : undefined}
        >
          <div
            className={classNames(Classes.CARD_BODY, bodyClassName, {
              [Classes.CONTAINER_FULL_HEIGHT]: fullHeight,
              [Classes.NO_SCROLL]: noScroll,
            })}
          >
            {arr.map((child, index) => {
              return (
                <Fragment key={index}>
                  {child}
                  {index + 1 < arr.length && <Divider horizontal />}
                </Fragment>
              );
            })}
          </div>
        </InverseBgProvider>
      </div>
    );
  }
}
